import type {
  Cache, UpdatesConfig, Variables, Data,
} from '@urql/exchange-graphcache';

import { updateSchoolCache } from './updateImplementationsCache';
import invalidateQuery from '../util/invalidateQuery';

import type { RefCodeUpdateMutation, RefCodeUpdateMutationVariables } from '@/graphql/generated/graphql';

const refCodesMutations: UpdatesConfig['Mutation'] = {
  refCodeCreate: (_: Data, vars: Variables, cache: Cache) => {
    const id = vars.school_id as number;
    cache.invalidate('Query', 'refCodes', {
      search: {
        school_id: id,
      },
    });
    updateSchoolCache(cache, id);
  },
  refCodeUpdate: (data: RefCodeUpdateMutation, vars: RefCodeUpdateMutationVariables, cache: Cache) => {
    if (data.refCodeUpdate?.school_id) {
      updateSchoolCache(cache, data.refCodeUpdate.school_id);
    }
    invalidateQuery('rentersImplementation', cache);
    invalidateQuery('tuitionImplementation', cache);

    // If search_visible change
    const id = data.refCodeUpdate?.school_id as number;
    cache.invalidate('Query', 'refCodes', {
      search: { school_id: id },
    });
  },
};

export default refCodesMutations;
